module.exports = __webpack_public_path__ + "static/media/appImage2.953bb722.svg";